import {Route} from 'react-router-dom'
import PrivateRoute from "context/PrivateRoute";
import MainMaintenance from "./MainMaintenance";
import ViewTasks from "./ViewTasks";
import ViewProgrammingTasks from 'views/maintenance/ViewProgrammingTasks';
import ViewOrders from 'views/maintenance/ViewOrders';
import ViewIncidences from 'views/maintenance/ViewIncidences';

const RoutesMaintenance = () => {

    return (
        <>
            <Route path="maintenance/" element={<PrivateRoute><MainMaintenance/></PrivateRoute>}/>
            <Route path="maintenance/tasks/" element={<PrivateRoute><ViewTasks/></PrivateRoute>}/>
            <Route path="maintenance/programming/" element={<PrivateRoute><ViewProgrammingTasks/></PrivateRoute>}/>
            <Route path="maintenance/orders/" element={<PrivateRoute><ViewOrders/></PrivateRoute>}/>
            <Route path="maintenance/incidence/" element={<PrivateRoute><ViewIncidences/></PrivateRoute>}/>
        </>
    )
}
export default RoutesMaintenance;